import { render, staticRenderFns } from "./ShowPAF.vue?vue&type=template&id=0dcbda00"
import script from "./ShowPAF.vue?vue&type=script&lang=js"
export * from "./ShowPAF.vue?vue&type=script&lang=js"
import style0 from "./ShowPAF.vue?vue&type=style&index=0&id=0dcbda00&prod&lang=css"
import style1 from "./ShowPAF.vue?vue&type=style&index=1&id=0dcbda00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports